import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    userInfo:{},
    goodsCount:''
  },
  getters:{
    get_userInfo(state){
      if(!state.userInfo.utoken){
        state.userInfo=JSON.parse(window.sessionStorage.getItem("userInfo")) || {}
      }
      return state.userInfo
    },
    get_goodsCount(state){
      if(!state.goodsCount){
        state.goodsCount=window.sessionStorage.getItem("goodsCount") || 0
      }
      return state.goodsCount
    }
  },
  mutations: {
    set_userInfo(state,data){
      window.sessionStorage.setItem("userInfo",JSON.stringify(data.data))
      state.userInfo=data.data
    },
    set_goodsCount(state,data){
      window.sessionStorage.setItem("goodsCount",data.num)
      state.goodsCount=data.num
    }
  },
  actions: {}
})
